var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"singleSignOn"},[_c('div',{staticClass:"content"},[_c('h3',[_vm._v(_vm._s(_vm.newText))]),_c('button',{on:{"click":_vm.openLogin}},[_vm._v(" 前往登录页 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }